import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import type { PaymentType } from 'src/app/shared/utils/payments';

import { usePromoteFormState } from '../../../formContext/formState';
import { useTracking } from '../useTracking';

export function useOnTokenInvalid(): (paymentType: PaymentType, err: Error) => void {
	const [, { clearLoading }] = usePromoteFormState();
	const { trackSubmitInvalid } = useTracking();
	const { errorReporter } = useUtilityContext();

	return function onTokenInvalid(paymentType: PaymentType, err: Error): void {
		clearLoading();
		trackSubmitInvalid({ paymentType, errorMessage: err.message });
		void errorReporter.report(
			{
				error: new Error('Payment failed due to invalid token', { cause: err }),
				params: { paymentType },
			},
			{
				severity: 'warning',
			},
		);
	};
}
